import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import LaunchPlan from './components/LaunchPlan';
import FirstTrade from './components/FirstTrade';
import TechDeploy from './components/TechDeploy';
import DataBoard from './components/DataBoard';
import Cta from './components/Cta';

export default function Launch() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="0#首发 | 帝星数商综合体 · 万村万店首发"
        description="九畴云铺0#帝星数商综合体首发方案，从定位升级、首笔交易到技术部署与数据看板，完成城市端验证。"
        keywords="0#首发,帝星数商综合体,首笔交易,万村万店,数字消费"
        path="/launch"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: '0#首发 · 帝星数商综合体 · 万村万店首发',
          about: '帝星数商综合体首发、首笔交易、万村万店',
        }}
      />
      <main>
        <Hero />
        <LaunchPlan />
        <FirstTrade />
        <TechDeploy />
        <DataBoard />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}